module.exports = new __parcel__URL__("background-light.c76a8e81.svg").toString();